import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import {
  commonSelectors,
  createQcsResourceCacheToState,
  createQcsThunks,
  createResourceEntityAdapter,
  qcsResourceShouldPersist,
  qcsResourceStateToCache,
} from '../core/resourceSliceUtils';
import { mileageTrackerTripsApi } from './mileageTrackerApi';
import { MILEAGE_TRACKER_REDUCER_KEY, type MileageTrackerState, type MileageTrackerType } from './mileageTrackerTypes';

const initialState: MileageTrackerState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};
const log = getLogger('app-components/flux/mileageTracker/mileageTrackerSlice.ts');

const entityAdapter = createResourceEntityAdapter<MileageTrackerType>();
const entitySelectors = entityAdapter.getSelectors();

export const stateToCacheMileageTracker = qcsResourceStateToCache;
export const shouldPersistMileageTracker = qcsResourceShouldPersist;
export const cacheToStateMileageTracker = createQcsResourceCacheToState(
  entityAdapter,
  entityAdapter.getInitialState(initialState),
);

export const slice = createAppSlice({
  name: MILEAGE_TRACKER_REDUCER_KEY,
  initialState: entityAdapter.getInitialState(initialState),
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        dispatch(mileageTrackerActions.fetch());
      },
      api: mileageTrackerTripsApi,
      adapter: entityAdapter,
      log,
    }),
  selectors: {
    ...entitySelectors,
    ...commonSelectors,
  },
});

export const mileageTrackerActions = slice.actions;
export const mileageTrackerSelectors = slice.selectors;
export { slice as mileageTrackerSlice };

export default slice.reducer;
